import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { useNavigation } from './navigation';
import { Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';
import { useCommonStore } from '@/store/commonStore';

const DEFAULT_TIMER = 7000;

export function useTimeoutRegistrationModal(timer = DEFAULT_TIMER) {
  const [isRegShown, setIsRegShown] = useState(false);
  const pathname = usePathname();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUser = useCommonStore.use.pendingUser();

  const { navigate } = useNavigation();
  const open = useModalsStore.use.open();
  const modal = useModalsStore.use.modal();

  useEffect(() => {
    if (isAuthenticated || pendingUser || modal || isRegShown) return;

    const timeoutId = setTimeout(() => {
      open(Modals.Registration);
      setIsRegShown(true);
    }, timer);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    isAuthenticated,
    navigate,
    open,
    pathname,
    pendingUser,
    timer,
    modal,
    isRegShown,
  ]);
}
